(function () {
  'use strict';
  var L = window.EmpressQuickBuyLib;
  if (!L) return;

  var i18n = {
    add: 'Adicionar',
    adding: 'Adicionando…',
    error: 'Erro',
    select_size: 'Selecione',
    installments: 'Em até 6X {{ price }} sem juros',
    selected_total: 'Seleccionado: {{ count }} produtos - Total {{ total }}',
    selected_one: 'Seleccionado: 1 produto - Total {{ total }}'
  };
  var i18nEl = document.getElementById('empress-qb-i18n');
  if (i18nEl) {
    try { i18n = Object.assign(i18n, JSON.parse(i18nEl.textContent)); } catch (e) {}
  }

  function parseCardJson(card) {
    try { return JSON.parse(card.getAttribute('data-empress-qb-json')); } catch (e) { return null; }
  }

  function setError(el, msg) {
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = msg;
  }

  function addToCart(ids, btn, errorEl, onSuccess) {
    if (!ids || !ids.length) return;
    var payload = L.buildAddPayload(ids);
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = i18n.adding;
    setError(errorEl, null);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || i18n.error); });
        return r.json();
      })
      .then(function () {
        if (onSuccess) onSuccess();
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: ids.length }
        }));
      })
      .catch(function () { setError(errorEl, i18n.error); })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  }

  // Document-level event delegation for size buttons
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-empress-qb-size]');
    if (sizeBtn && !sizeBtn.disabled) {
      var card = sizeBtn.closest('[data-empress-qb-card]');
      if (!card) return;
      card.querySelectorAll('[data-empress-qb-size]').forEach(function (b) {
        b.classList.toggle('is-selected', b === sizeBtn);
      });
      var addBtn = card.querySelector('[data-empress-qb-add]');
      var errorEl = card.querySelector('[data-empress-qb-error]');
      if (addBtn) addBtn.hidden = false;
      setError(errorEl, null);
    }
  });

  // Document-level event delegation for add button
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-empress-qb-add]');
    if (!addBtn) return;
    var card = addBtn.closest('[data-empress-qb-card]');
    if (!card) return;
    var errorEl = card.querySelector('[data-empress-qb-error]');
    var data = parseCardJson(card);
    var selectedBtn = card.querySelector('[data-empress-qb-size].is-selected');
    var id = selectedBtn ? selectedBtn.getAttribute('data-variant-id') : null;
    if (!id && data && data.variants) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) { id = String(data.variants[i].id); break; }
      }
    }
    if (!id) return;
    addToCart([Number(id)], addBtn, errorEl);
  });

  function initCards(root) {
    // Optional: any one-time setup per card if needed (currently none)
  }

  // Modal de conjuntos
  var modal = null;
  var modalImg = null;
  var modalTitle = null;
  var modalPrice = null;
  var modalColors = null;
  var modalTop = null;
  var modalBottom = null;
  var modalTopPrice = null;
  var modalTopInstallments = null;
  var modalBottomPrice = null;
  var modalBottomInstallments = null;
  var modalTotal = null;
  var modalError = null;
  var modalAddBtn = null;
  var currentProduct = null;
  var selectedTopId = null;
  var selectedBottomId = null;
  var selectedTopCents = 0;
  var selectedBottomCents = 0;
  var originalSiblings = [];

  function normalizeAjaxProduct(p) {
    var parsed = L.parseProductJson(p);
    parsed.siblings = [];
    return parsed;
  }

  function formatPrice(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function formatInstallment(cents) {
    var part = Math.round((Number(cents) || 0) / 6);
    var priceLabel = formatPrice(part).replace(/\s/g, '');
    return String(i18n.installments || '').replace('{{ price }}', priceLabel);
  }

  function tTemplate(tpl, vars) {
    var out = String(tpl || '');
    Object.keys(vars || {}).forEach(function (key) {
      out = out.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), vars[key]);
    });
    return out;
  }

  function variantCents(variant) {
    if (!variant) return 0;
    return Number(variant.price) || 0;
  }

  function setPiecePrice(amountEl, installmentEl, cents) {
    if (amountEl) amountEl.textContent = formatPrice(cents);
    if (installmentEl) installmentEl.textContent = formatInstallment(cents);
  }

  function updateSetPricing() {
    if (!currentProduct) return;
    var topVariant = selectedTopId
      ? findVariantById(currentProduct.variants, selectedTopId)
      : L.firstAvailableByStyle(currentProduct.variants, 'Top');
    var bottomVariant = selectedBottomId
      ? findVariantById(currentProduct.variants, selectedBottomId)
      : L.firstAvailableByStyle(currentProduct.variants, 'Bottom');

    selectedTopCents = variantCents(topVariant);
    selectedBottomCents = variantCents(bottomVariant);
    setPiecePrice(modalTopPrice, modalTopInstallments, selectedTopCents);
    setPiecePrice(modalBottomPrice, modalBottomInstallments, selectedBottomCents);

    if (!modalTotal) return;
    var count = (selectedTopId ? 1 : 0) + (selectedBottomId ? 1 : 0);
    var total = selectedTopCents + selectedBottomCents;
    modalTotal.hidden = false;
    if (count === 1) {
      modalTotal.textContent = tTemplate(i18n.selected_one, { total: formatPrice(total) });
    } else {
      modalTotal.textContent = tTemplate(i18n.selected_total, {
        count: '2',
        total: formatPrice(total)
      });
    }
  }

  function findVariantById(variants, id) {
    if (!variants || id == null) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function renderSizeButtons(container, product, styleHint) {
    if (!container) return;
    container.innerHTML = '';
    var sizes = L.sizeValues(product.options_with_values);
    sizes.forEach(function (size) {
      var variant = L.findVariant(product.variants, { size: size, style: styleHint });
      var id = variant ? variant.id : null;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'empress-qb-modal__size';
      btn.textContent = size;
      btn.disabled = !id;
      if (!id) btn.classList.add('empress-qb-size--unavailable');
      btn.setAttribute('data-variant-id', id || '');
      btn.setAttribute('data-size', size);
      if (variant) btn.setAttribute('data-price', String(variant.price || 0));
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        container.querySelectorAll('.empress-qb-modal__size').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        if (styleHint === 'Top') {
          selectedTopId = id;
        } else {
          selectedBottomId = id;
        }
        updateAddButton();
        updateSetPricing();
      });
      container.appendChild(btn);
    });
  }

  function renderColorSwatches(container, product) {
    if (!container) return;
    container.innerHTML = '';
    var seen = {};
    var allProducts = [];
    function pushUnique(p) {
      if (!p || !p.handle || seen[p.handle]) return;
      seen[p.handle] = true;
      allProducts.push(p);
    }
    pushUnique(product);
    (originalSiblings || []).forEach(pushUnique);
    allProducts.forEach(function (p) {
      var swatch = document.createElement('button');
      swatch.type = 'button';
      swatch.className = 'empress-qb-modal__swatch';
      swatch.setAttribute('data-handle', p.handle);
      swatch.title = p.title || '';
      if (p.handle === product.handle) {
        swatch.classList.add('is-selected');
      }
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image;
        img.alt = p.title || '';
        img.width = 40;
        img.height = 50;
        swatch.appendChild(img);
      }
      swatch.addEventListener('click', function () {
        if (p.handle === product.handle) return;
        loadProductVariant(p.handle);
      });
      container.appendChild(swatch);
    });
  }

  function updateAddButton() {
    if (!modalAddBtn) return;
    modalAddBtn.disabled = !selectedTopId || !selectedBottomId;
  }

  function clearSelections() {
    selectedTopId = null;
    selectedBottomId = null;
    if (modalTop) {
      modalTop.querySelectorAll('.is-selected').forEach(function (b) {
        b.classList.remove('is-selected');
      });
    }
    if (modalBottom) {
      modalBottom.querySelectorAll('.is-selected').forEach(function (b) {
        b.classList.remove('is-selected');
      });
    }
    updateAddButton();
    updateSetPricing();
  }

  function loadProductVariant(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    setError(modalError, null);
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (data) {
        var normalized = normalizeAjaxProduct(data);
        if (!normalized.featured_image && data.featured_image) {
          normalized.featured_image = data.featured_image;
        }
        normalized.siblings = originalSiblings;
        currentProduct = normalized;
        if (modalImg) {
          modalImg.src = normalized.featured_image || '';
          modalImg.alt = normalized.title || '';
        }
        if (modalTitle) modalTitle.textContent = normalized.title || '';
        if (modalPrice) {
          modalPrice.hidden = true;
          modalPrice.textContent = '';
        }
        selectedTopId = null;
        selectedBottomId = null;
        renderSizeButtons(modalTop, normalized, 'Top');
        renderSizeButtons(modalBottom, normalized, 'Bottom');
        renderColorSwatches(modalColors, normalized);
        updateAddButton();
        updateSetPricing();
        setError(modalError, null);
      })
      .catch(function () {
        setError(modalError, i18n.error);
      });
  }

  function openModal(productData) {
    if (!modal) {
      modal = document.querySelector('[data-empress-qb-modal]');
      if (!modal) return;
      modalImg = modal.querySelector('[data-empress-qb-modal-img]');
      modalTitle = modal.querySelector('[data-empress-qb-modal-title]');
      modalPrice = modal.querySelector('[data-empress-qb-modal-price]');
      modalColors = modal.querySelector('[data-empress-qb-modal-colors]');
      modalTop = modal.querySelector('[data-empress-qb-modal-top]');
      modalBottom = modal.querySelector('[data-empress-qb-modal-bottom]');
      modalTopPrice = modal.querySelector('[data-empress-qb-top-price]');
      modalTopInstallments = modal.querySelector('[data-empress-qb-top-installments]');
      modalBottomPrice = modal.querySelector('[data-empress-qb-bottom-price]');
      modalBottomInstallments = modal.querySelector('[data-empress-qb-bottom-installments]');
      modalTotal = modal.querySelector('[data-empress-qb-modal-total]');
      modalError = modal.querySelector('[data-empress-qb-modal-error]');
      modalAddBtn = modal.querySelector('[data-empress-qb-modal-add]');

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-empress-qb-close]')) closeModal();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
      });

      if (modalAddBtn) {
        modalAddBtn.addEventListener('click', function () {
          if (!selectedTopId || !selectedBottomId) return;
          addToCart([selectedTopId, selectedBottomId], modalAddBtn, modalError, closeModal);
        });
      }
    }

    currentProduct = productData;
    originalSiblings = productData.siblings || [];
    selectedTopId = null;
    selectedBottomId = null;

    if (modalImg) {
      modalImg.src = productData.featured_image || '';
      modalImg.alt = productData.title;
    }
    if (modalTitle) modalTitle.textContent = productData.title;
    if (modalPrice) {
      modalPrice.hidden = true;
      modalPrice.textContent = '';
    }

    renderColorSwatches(modalColors, productData);
    renderSizeButtons(modalTop, productData, 'Top');
    renderSizeButtons(modalBottom, productData, 'Bottom');

    updateAddButton();
    updateSetPricing();
    setError(modalError, null);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    currentProduct = null;
    selectedTopId = null;
    selectedBottomId = null;
    originalSiblings = [];
  }

  // Document-level event delegation for modal open button (sets)
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-empress-qb-open-modal]');
    if (!openBtn) return;
    var card = openBtn.closest('[data-empress-qb-card]');
    if (!card) return;
    var data = parseCardJson(card);
    if (data) openModal(data);
  });

  window.EmpressQuickBuy = {
    initCards: initCards,
    addToCart: addToCart,
    parseCardJson: parseCardJson,
    i18n: i18n,
    setError: setError,
    openModal: openModal
  };
})();
